/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * email_service
 * OpenAPI spec version: 0.1.0
 */

export type BackfillJobStatus =
  (typeof BackfillJobStatus)[keyof typeof BackfillJobStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackfillJobStatus = {
  Init: 'Init',
  InProgress: 'InProgress',
  Complete: 'Complete',
  Cancelled: 'Cancelled',
  Failed: 'Failed',
} as const;
